// ============================================================================
// CONNECTION STATUS - Overlay showing BroadcastChannel connected/disconnected
// Auto-hides 3 seconds after connecting; stays visible when disconnected
// ============================================================================

import React, { useState, useEffect } from 'react';
import { useSecondScreenData } from '../../contexts/SecondScreenContext';

const ConnectionStatus: React.FC = () => {
  const { isConnected } = useSecondScreenData();
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (isConnected) {
      const timer = setTimeout(() => setVisible(false), 3000);
      return () => clearTimeout(timer);
    } else {
      setVisible(true);
    }
  }, [isConnected]);

  if (!visible) return null;

  return (
    <div className="absolute top-4 right-4 z-50 flex items-center gap-2 px-3 py-1.5 rounded-lg bg-black/60 backdrop-blur-sm border border-white/10">
      <div
        className={`size-2 rounded-full ${
          isConnected ? 'bg-green-500 animate-pulse' : 'bg-red-500'
        }`}
      />
      <span className="text-xs font-medium text-white/80">
        {isConnected ? 'Connected to session' : 'Waiting for connection...'}
      </span>
    </div>
  );
};

export default ConnectionStatus;
